/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Split_PullInputs */

const en_us2_profile_editors_split_pull = /** @type {(inputs: Profile_Editors_Split_PullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pull`)
};

const pt_br2_profile_editors_split_pull = /** @type {(inputs: Profile_Editors_Split_PullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puxar`)
};

const es_419_profile_editors_split_pull = /** @type {(inputs: Profile_Editors_Split_PullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tirón`)
};

const pt_pt2_profile_editors_split_pull = /** @type {(inputs: Profile_Editors_Split_PullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puxar`)
};

const fr_fr2_profile_editors_split_pull = /** @type {(inputs: Profile_Editors_Split_PullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tirage`)
};

const de_de2_profile_editors_split_pull = /** @type {(inputs: Profile_Editors_Split_PullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziehen`)
};

const it_it2_profile_editors_split_pull = /** @type {(inputs: Profile_Editors_Split_PullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tirata`)
};

/**
* | output |
* | --- |
* | "Pull" |
*
* @param {Profile_Editors_Split_PullInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_split_pull = /** @type {((inputs?: Profile_Editors_Split_PullInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Split_PullInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_split_pull(inputs)
	if (locale === "es-419") return es_419_profile_editors_split_pull(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_split_pull(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_split_pull(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_split_pull(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_split_pull(inputs)
	return en_us2_profile_editors_split_pull(inputs)
});
export { profile_editors_split_pull as "profile-editors.split_pull" }